import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { PagerList, GlobalInfo, FPMessage, Severities, PageKey, RoleAccess } from '../../shared/shared.model';
import { FormControl, FormGroup, FormBuilder, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { BaseComponent } from '../../shared/base.component';
import { SharedService, Status, RowsPerOptions } from '../../shared/shared.service';
import { Observable } from 'rxjs';
import { API } from '../../core/app-config';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { Message, ConfirmationService, SelectItem, MultiSelectModule } from 'primeng/primeng';
import { LoaderService } from '../.././shared/loader.service';
import { CapitalizeFirstPipe } from '../.././shared/pipes/custom-pipes.pipe';
import { ValidationService } from '../../technician/technician-jobs/technician-common-validation';
import { TechnicianJobService } from '../../technician/technician-jobs/technician-jobs.service';
import { ClosePopup, AttachmentsModel, AttachmentsListModel, WoAttachement, Titles, RefTaskAttachment } from '../../inventory/part/part.model';
import { PartService } from '../../inventory/part/part.service';


declare var google: any;
@Component({
    // moduleId: module.id,
    selector: 'part-attachement-lookup',
    templateUrl: 'part-attachement-lookup.html',
    providers: [DatePipe]
})

export class PartAttachementComponent extends BaseComponent implements OnInit {


    roleAttachments: RoleAccess;
    @Input() isPageReadOnly: boolean = false;
    @Input() partId: number;

    @Output() Close = new EventEmitter();

    AllButtonDisable: boolean = true;;
    //model
    message: FPMessage;
    attachmentsList: AttachmentsModel[];
    attachmentsFilter: AttachmentsListModel[];
    attachmentsModel: AttachmentsModel;

    public reftaskAttach: RefTaskAttachment[] = [];
    public taskattach: RefTaskAttachment;

    jobId: number;
    customerId: number;
    HeaderName: string;
    woJobId: number;
    companyId: number;
    eventName: string;
    woWorkOrderId: number;
    jobNnumber: number[];
    woCategoryId: number;
    technicianId: number;
    isGridShowHide: Boolean = false;
    isGridThumbHide: boolean = true;
    isOpenAttachments: boolean;
    photoId: number = 23;
    documentId: number = 24;
    togglelist: boolean = false;
    isShowToggle: boolean = false;

    
    constructor(protected translateService: TranslateService,
        protected sharedService: SharedService, private formBuilder: FormBuilder, private route: ActivatedRoute,
        private datePipe: DatePipe, private partService: PartService, private _technicianJobService: TechnicianJobService, private confirmationService: ConfirmationService) {
        super(sharedService, translateService)
    }

    ngOnInit() {
        
        this.route.params.subscribe(params => {
            this.jobId = params['id'];
            this.woCategoryId = params['woCategoryId'];
            this.woWorkOrderId = params['workOrderId'];
            this.technicianId = params['TechnicianId'];
        });

        this.companyId = super.globalInfo().CompanyId;
        this.getAttachementsDetails();
    }

    getAttachementsDetails() {

        this.attachmentsList = [];
        this.partService.getAttachementsDetails(this.companyId, 0, this.partId)
            .subscribe(s => {
                
                this.attachmentsList = s;
                this.attachmentsFilter = [];
                this.isShowToggle = this.attachmentsList.length > 0;
                //   this.attachmentDateFormat(this.attachmentsList);
                for (let file of this.attachmentsList) {
                    //file.Type = file.AttachementType;
                   // file.AttachementType = file.FileName.split('.').pop();

                    if (file.AttachementType == "image/png" || file.AttachementType == "image/jpeg" || file.AttachementType == "image/gif")
                        file.DocType = true;
                    else if (file.AttachementType == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || file.AttachementType == "application/vnd.ms-excel") {
                        file.DocType = false;
                        file.DocThumbImage = "../assets/img/logo/xls.png";

                    }
                    else if (file.AttachementType == "application/vnd.openxmlformats-officedocument.wordprocessingml.document" || file.AttachementType == "application/msword") {
                        file.DocType = false;
                        file.DocThumbImage = "../assets/img/logo/document.png";
                    }
                    else if (file.AttachementType == "application/vnd.openxmlformats-officedocument.presentationml.presentation") {
                        file.DocType = false;
                        file.DocThumbImage = "../assets/img/logo/ppt.png";
                    }
                    else if (file.AttachementType == "text/plain") {
                        file.DocType = false;
                        file.DocThumbImage = "../assets/img/logo/document.png";
                    }

                    else if (file.AttachementType == "application/pdf") {
                        file.DocType = false;
                        file.DocThumbImage = "../assets/img/logo/pdf.png";
                    }
                    else if (file.AttachementType == "video/mp4") {
                        file.DocType = false;
                        file.DocThumbImage = "../assets/img/logo/movie.png";
                    }
                    else if (file.AttachementType == "audio/mp3") {
                        file.DocType = false;
                        file.DocThumbImage = "../assets/img/logo/mp3.png";
                    }
                    else if (file.AttachementType == "dwg") {
                        file.DocType = false;
                        file.DocThumbImage = "../assets/img/logo/autocad.dwg";
                    }
                    else {
                        file.DocType = false;
                        file.DocThumbImage = "../assets/img/logo/unknown.png";
                    }
                    // file.CapturedDateFormat = this.datetimeFormat(file.CapturedDate);
                    file.LastUpdate = this.datetimeFormat(file.LastUpdate);

                    this.attachmentsFilter.push(file);

                }
                console.log(this.attachmentsFilter);
            });
    }

    attachmentDateFormat(attachModel: AttachmentsListModel[]) {
        this.attachmentsFilter = attachModel.map(s => {
            // s.CapturedDateFormat = this.datetimeFormat(s.CapturedDate);
            s.LastUpdate = this.datetimeFormat(s.LastUpdate);
            return s;
        })
    }

    addNewAttachments() {
        
        this.isOpenAttachments = true;
        this.HeaderName = this.translate.instant('ADDATTACHMENT');
        this.eventName = "add";
        this.woJobId = this.jobId;
        this.woWorkOrderId = this.partId;
    }

    editAttachments(model: AttachmentsModel) {
        
        this.attachmentsModel = model;
        this.isOpenAttachments = true;
        this.HeaderName = this.translate.instant('EDITATTACHMENT');
        this.eventName = "edit";
        this.woJobId = this.jobId;
        this.woWorkOrderId = this.partId;
    }

    filterPhotoDocument(id: any) {
        if (+id !== 0)
            this.attachmentsFilter = this.attachmentsList.filter(f => f.AttachmentCategoryId == +id);
        else
            this.attachmentsFilter = this.attachmentsList;
    }

    deleteAttachments(model: AttachmentsModel) {
        
        this.confirmationService.confirm({
            message: this.translate.instant('5001'),
            header: 'Delete Confirmation',
            icon: 'fa fa-trash',
            accept: () => {
                //Actual logic to perform a confirmation
                this.partService.deleteAttachement(this.companyId, model.PartAttachmentId)
                    .subscribe(s => {
                        this.message = s.Message;
                        if (this.message.MessageCode == "1003") {
                            this.sharedService.notification.emit({
                                severity: Severities[this.message.Severity],
                                summary: CapitalizeFirstPipe.prototype.transform(Severities[this.message.Severity]),
                                detail: this.translate.instant('ATTACHMENT') + " " + this.translate.instant(this.message.MessageCode)
                            });
                        }
                        else {
                            this.sharedService.notification.emit({
                                severity: Severities[this.message.Severity],
                                summary: CapitalizeFirstPipe.prototype.transform(Severities[this.message.Severity]),
                                detail: this.translate.instant(this.message.MessageCode)
                            });
                        }
                        if (s.Message.Severity == Severities.success) {
                            this.getAttachementsDetails();
                        }
                    });
            }
        });
    }

    dowoloadFile(woAttachId: number) {
        //var url = API.WORKORDER + '/Download?CompanyId=' + this.companyId + "&WoAttachmentId=" + woAttachId;
        var url = API.ATTACHEMNT + '/ManagePartDownload?CompanyId=' + this.companyId + "&PartAttachmentId=" + woAttachId;
        window.location.href = url;//"http://localhost:13632/api/workorder/Download?CompanyId=" + this.companyId + "&WoAttachmentId=" + woAttachId;
        return;
    }

    closeAttachmentPopup(popupClose: ClosePopup) {

        if (popupClose.Responce === true) {
            this.getAttachementsDetails();
            this.isOpenAttachments = false;
        } else {
            this.isOpenAttachments = false;
        }
    }

    showThumbNailView() {
        if (this.togglelist = this.togglelist == true ? false : true) {
            this.isGridShowHide = true;
            this.isGridThumbHide = false;

        } else {
            this.isGridShowHide = false;
            this.isGridThumbHide = true;
        }
    }

    closePreview() {
        this.Close.emit(true);
    }

    datetimeFormat(dateTimeVal: any): any {

        if (dateTimeVal == "0001-01-01T00:00:00" || dateTimeVal == "" || dateTimeVal == null || dateTimeVal == "1/1/0001 12:00:00 AM") {
            return "";
        } else {
            return this.datePipe.transform(dateTimeVal, 'shortDate') + " " + this.datePipe.transform(dateTimeVal, 'shortTime')
        }
    }

    /**End Attachments */

}